<!-- 全周期发运计划维护（月计划；日计划已独立为 /car-storage/daily-management/index） -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <!-- <template slot-scope="scope" slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.crud.rowAdd()">新建计划
        </el-button>
      </template> -->
      <template #menu="{ size, row, index }">
        <el-button v-if="row.auditFlag == 2" @click="unAudit(row.id)"
                  text
                  type="text"
                  size="small">
          取消审核
        </el-button>
        <el-button v-if="row.auditFlag == 0" @click="audit(row.id)"
                  text
                  type="text"
                  size="small">
          审核
        </el-button>
      </template>
    </avue-crud>
    <select-contract ref="selectContract" @replace="replace" />
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, audit, unAudit, exportExcel } from "./api";
import { searchTimeConfig, rulesInput } from "@/basic-common/util/common";
import SelectContract from "@/views/railway-management/transportplan/components/select-contract.vue";
import validator from "@/util/validate";
import { downloadXls } from '@/util/util'

export default {
  name: "store-management/index/index",
  mixins: [crudMixins],
  components: {
    SelectContract
  },
  data () {
    return {
      apiConfig: {},
      exportLoading: false,
      defaultParams: {
        "businessType": "3", //必须传且为3 汽车入库
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn:false,
        delBtn:false,
        column: [],
      },
    }
  },
  created () {
    this.apiConfig = {
      getList,
      add: (row) => add({ ...row, ...this.defaultParams }),
      update: (row) => update({ ...row, ...this.defaultParams }),
      remove,
      getDetail
    }
    this.defaultParams = { ...this.defaultParams, "planType": '0' }
    this.applyPlanTypeColumns()
  },
  methods: {
    buildColumns () {
      const that = this
      const planNameRules = [
        { required: true, message: '请输入计划名称', trigger: 'blur' },
      ]
      const cols = [
        {
          label: '计划名称',
          prop: 'planName',
          width: 150,
          rules: planNameRules,
          maxlength: 32,
          search: true,
        },
      ]
      cols.push(
        {
          label: '客户',
          prop: 'custNo',
          overHidden: true,
          type: 'select',
          remote: true,
          dicUrl: '/api/produce/blade-dept/select/distinct/select',
          props: {
            label: 'deptName',
            value: 'id'
          },
          width: 150,
          search: true,
        },
        {
          label: '物资名称',
          prop: 'cargoName',
          type: 'select',
          remote: true,
          dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
          props: {
            label: 'varName',
            value: 'id'
          },
          disabled: true
        },
        {
          label: '计划数量(吨)',
          prop: 'planTotalWeight',
          maxlength: 12,
          rules: [
            { required: true, trigger: "blur", validator: validator.positiveNum2 }
          ],
        },
        {
          label: '计划车数',
          prop: 'planTruckCount',
          type: 'number',
          min: 0,
          precision: 0,
          width: 110,
        },
        {
          label: '开始时间',
          prop: 'intervalStartTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 165,
          hide: true,
          pickerOptions: {
            disabledDate (time) {
              const now = new Date();
              const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
              const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
              return time < currentMonthStart || time >= nextMonthStart;
            }
          },
          rules: rulesInput(2),
        },
        {
          label: '结束时间',
          prop: 'intervalEndTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 165,
          hide: true,
          pickerOptions: {
            disabledDate (time) {
              const formData = that.form;
              const startTime = formData.intervalStartTime
                ? new Date(formData.intervalStartTime).getTime() : 0;
              const now = new Date();
              const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
              const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
              return (
                time < currentMonthStart ||
                time >= nextMonthStart ||
                (startTime && time.getTime() < startTime)
              );
            }
          },
          rules: rulesInput(2),
        },
        {
          label: '合同开始时间',
          prop: 'contractStartTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          hide: true,
          disabled: true,
          showColumn: false,
        },
        {
          label: '合同结束时间',
          prop: 'contractEndTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          minWidth: 120,
          hide: true,
          disabled: true,
          showColumn: false,
        },
        {
          label: '合同名称',
          prop: 'contractName',
          search: true,
          overHidden: true,
          width: 150,
          type: 'input',
          remote: true,
          readonly: true,
          rules: rulesInput(2),
          click: () => {
            const { dialogForm } = this.$refs.crud.$refs
            if (dialogForm.boxVisible) {
              this.$refs.selectContract.open('2')
            }
          }
        },
        {
          label: '创建时间',
          prop: 'createTime',
          addDisplay: false,
          editDisplay: false,
        },
        {
          ...searchTimeConfig,
          paramsKey: ["startTime", "endTime"],
        }
      )
      return cols
    },
    applyPlanTypeColumns () {
      this.option.column = this.buildColumns()
      this.setPlaceholder()
      this.queryAutoArrange()
    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    },
    audit(id){
      this.$confirm_primary('审核')
        .then(() => {
          return audit(id)
        })
        .then((res) => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: res.data.msg,
          })
        })
    },
    unAudit(id){
      this.$confirm_primary('取消审核')
        .then(() => {
           return unAudit(id)
        })
        .then((res) => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: res.data.msg,
          })
        })
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `汽运入库月计划_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
